export default {
	title: 'Bearing Library',
	selectAll: 'Select All',
	selectedCount: 'Selected {count} items',
	batchDelete: 'Batch Delete',
	batchDeleteWithCount: 'Batch Delete ({count})',
	noData: {
		title: 'No Bearing Data',
		description: 'No bearing data found'
	},
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Delete successful',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty'
	},
	form: {
		designation: 'Bearing Designation',
		brand: 'Bearing Brand',
		bpfo: 'BPFO',
		bpfi: 'BPFI',
		bsf: 'BSF',
		ftf: 'FTF',
		placeholder: {
			designation: 'Please enter bearing designation',
			brand: 'Please enter bearing brand',
			bpfo: 'Please enter BPFO',
			bpfi: 'Please enter BPFI',
			bsf: 'Please enter BSF',
			ftf: 'Please enter FTF'
		}
	},
	table: {
		designation: 'Bearing Designation',
		brand: 'Bearing Brand',
		bpfo: 'BPFO',
		bpfi: 'BPFI',
		bsf: 'BSF',
		ftf: 'FTF'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm'
	}
}
